import * as Types from '../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RevokeAdminRolesMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  userSubs: Array<Types.InputMaybe<Types.Scalars['String']['input']>>;
}>;


export type RevokeAdminRolesMutation = { __typename?: 'Mutation', revokeAdminRoles?: Array<{ __typename?: 'Error', type: string, location: Array<string>, context?: string | null } | null> | null };

export type AdminListQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type AdminListQuery = { __typename?: 'Query', admins?: Array<{ __typename?: 'Admin', aliases: Array<string>, emails: Array<string>, name: string, sub: string, canCreateEndpoints: boolean } | null> | null };

export type AddAdminRoleMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  email: Types.Scalars['String']['input'];
  canCreateEndpoints: Types.Scalars['Boolean']['input'];
  language?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type AddAdminRoleMutation = { __typename?: 'Mutation', addAdminRole: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } };

export type GlobalNumberSearchQueryVariables = Types.Exact<{
  filterString: Types.Scalars['String']['input'];
}>;


export type GlobalNumberSearchQuery = { __typename?: 'Query', searchNumbers: { __typename?: 'GlobalNumberSearchResult', hasMore: boolean, numbers: Array<{ __typename?: 'FoundNumber', e164?: string | null, shortNumber: string, macAddress?: string | null, domain: { __typename?: 'FoundDomain', id: number, name: string }, endpoint: { __typename?: 'FoundEndpoint', id: number, type: string } }> } };

export type RoleDomainNameQueryVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;


export type RoleDomainNameQuery = { __typename?: 'Query', domains?: { __typename?: 'DomainList', items: Array<{ __typename?: 'Domain', id: number } | null> } | null };


export const RevokeAdminRolesDocument = gql`
    mutation RevokeAdminRoles($domainId: Int!, $userSubs: [String]!) {
  revokeAdminRoles(domainId: $domainId, userSubs: $userSubs) {
    type
    location
    context
  }
}
    `;
export type RevokeAdminRolesMutationFn = Apollo.MutationFunction<RevokeAdminRolesMutation, RevokeAdminRolesMutationVariables>;

/**
 * __useRevokeAdminRolesMutation__
 *
 * To run a mutation, you first call `useRevokeAdminRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAdminRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAdminRolesMutation, { data, loading, error }] = useRevokeAdminRolesMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      userSubs: // value for 'userSubs'
 *   },
 * });
 */
export function useRevokeAdminRolesMutation(baseOptions?: Apollo.MutationHookOptions<RevokeAdminRolesMutation, RevokeAdminRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeAdminRolesMutation, RevokeAdminRolesMutationVariables>(RevokeAdminRolesDocument, options);
      }
export type RevokeAdminRolesMutationHookResult = ReturnType<typeof useRevokeAdminRolesMutation>;
export type RevokeAdminRolesMutationResult = Apollo.MutationResult<RevokeAdminRolesMutation>;
export type RevokeAdminRolesMutationOptions = Apollo.BaseMutationOptions<RevokeAdminRolesMutation, RevokeAdminRolesMutationVariables>;
export const AdminListDocument = gql`
    query AdminList($domainId: Int!) {
  admins(domainId: $domainId) {
    aliases
    emails
    name
    sub
    canCreateEndpoints
  }
}
    `;

/**
 * __useAdminListQuery__
 *
 * To run a query within a React component, call `useAdminListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminListQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useAdminListQuery(baseOptions: Apollo.QueryHookOptions<AdminListQuery, AdminListQueryVariables> & ({ variables: AdminListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminListQuery, AdminListQueryVariables>(AdminListDocument, options);
      }
export function useAdminListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminListQuery, AdminListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminListQuery, AdminListQueryVariables>(AdminListDocument, options);
        }
export function useAdminListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminListQuery, AdminListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminListQuery, AdminListQueryVariables>(AdminListDocument, options);
        }
export type AdminListQueryHookResult = ReturnType<typeof useAdminListQuery>;
export type AdminListLazyQueryHookResult = ReturnType<typeof useAdminListLazyQuery>;
export type AdminListSuspenseQueryHookResult = ReturnType<typeof useAdminListSuspenseQuery>;
export type AdminListQueryResult = Apollo.QueryResult<AdminListQuery, AdminListQueryVariables>;
export const AddAdminRoleDocument = gql`
    mutation AddAdminRole($domainId: Int!, $email: String!, $canCreateEndpoints: Boolean!, $language: String) {
  addAdminRole(
    domainId: $domainId
    email: $email
    canCreateEndpoints: $canCreateEndpoints
    language: $language
  ) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type AddAdminRoleMutationFn = Apollo.MutationFunction<AddAdminRoleMutation, AddAdminRoleMutationVariables>;

/**
 * __useAddAdminRoleMutation__
 *
 * To run a mutation, you first call `useAddAdminRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdminRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdminRoleMutation, { data, loading, error }] = useAddAdminRoleMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      email: // value for 'email'
 *      canCreateEndpoints: // value for 'canCreateEndpoints'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAddAdminRoleMutation(baseOptions?: Apollo.MutationHookOptions<AddAdminRoleMutation, AddAdminRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAdminRoleMutation, AddAdminRoleMutationVariables>(AddAdminRoleDocument, options);
      }
export type AddAdminRoleMutationHookResult = ReturnType<typeof useAddAdminRoleMutation>;
export type AddAdminRoleMutationResult = Apollo.MutationResult<AddAdminRoleMutation>;
export type AddAdminRoleMutationOptions = Apollo.BaseMutationOptions<AddAdminRoleMutation, AddAdminRoleMutationVariables>;
export const GlobalNumberSearchDocument = gql`
    query GlobalNumberSearch($filterString: String!) {
  searchNumbers(filterString: $filterString) {
    numbers {
      domain {
        id
        name
      }
      e164
      shortNumber
      macAddress
      endpoint {
        id
        type
      }
    }
    hasMore
  }
}
    `;

/**
 * __useGlobalNumberSearchQuery__
 *
 * To run a query within a React component, call `useGlobalNumberSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalNumberSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalNumberSearchQuery({
 *   variables: {
 *      filterString: // value for 'filterString'
 *   },
 * });
 */
export function useGlobalNumberSearchQuery(baseOptions: Apollo.QueryHookOptions<GlobalNumberSearchQuery, GlobalNumberSearchQueryVariables> & ({ variables: GlobalNumberSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalNumberSearchQuery, GlobalNumberSearchQueryVariables>(GlobalNumberSearchDocument, options);
      }
export function useGlobalNumberSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalNumberSearchQuery, GlobalNumberSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalNumberSearchQuery, GlobalNumberSearchQueryVariables>(GlobalNumberSearchDocument, options);
        }
export function useGlobalNumberSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GlobalNumberSearchQuery, GlobalNumberSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GlobalNumberSearchQuery, GlobalNumberSearchQueryVariables>(GlobalNumberSearchDocument, options);
        }
export type GlobalNumberSearchQueryHookResult = ReturnType<typeof useGlobalNumberSearchQuery>;
export type GlobalNumberSearchLazyQueryHookResult = ReturnType<typeof useGlobalNumberSearchLazyQuery>;
export type GlobalNumberSearchSuspenseQueryHookResult = ReturnType<typeof useGlobalNumberSearchSuspenseQuery>;
export type GlobalNumberSearchQueryResult = Apollo.QueryResult<GlobalNumberSearchQuery, GlobalNumberSearchQueryVariables>;
export const RoleDomainNameDocument = gql`
    query RoleDomainName($name: String!) {
  domains(filter: $name) {
    items {
      id
    }
  }
}
    `;

/**
 * __useRoleDomainNameQuery__
 *
 * To run a query within a React component, call `useRoleDomainNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleDomainNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleDomainNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRoleDomainNameQuery(baseOptions: Apollo.QueryHookOptions<RoleDomainNameQuery, RoleDomainNameQueryVariables> & ({ variables: RoleDomainNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleDomainNameQuery, RoleDomainNameQueryVariables>(RoleDomainNameDocument, options);
      }
export function useRoleDomainNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleDomainNameQuery, RoleDomainNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleDomainNameQuery, RoleDomainNameQueryVariables>(RoleDomainNameDocument, options);
        }
export function useRoleDomainNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RoleDomainNameQuery, RoleDomainNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RoleDomainNameQuery, RoleDomainNameQueryVariables>(RoleDomainNameDocument, options);
        }
export type RoleDomainNameQueryHookResult = ReturnType<typeof useRoleDomainNameQuery>;
export type RoleDomainNameLazyQueryHookResult = ReturnType<typeof useRoleDomainNameLazyQuery>;
export type RoleDomainNameSuspenseQueryHookResult = ReturnType<typeof useRoleDomainNameSuspenseQuery>;
export type RoleDomainNameQueryResult = Apollo.QueryResult<RoleDomainNameQuery, RoleDomainNameQueryVariables>;